__turbopack_context__.v({
  "current": "_1pE-0G_current",
  "last": "_1pE-0G_last",
  "next": "_1pE-0G_next",
  "paginationContainer": "_1pE-0G_paginationContainer",
  "paginationLink": "_1pE-0G_paginationLink",
  "previous": "_1pE-0G_previous",
});
